import React from 'react'

const LogoUI8 = ({ style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M16.718 3.958c1.612-.878 4.222-.878 5.837 0l13.8 7.505c1.61.877 2.918 3.073 2.918 4.903V31.1c0 1.83-1.304 4.023-2.919 4.901l-13.8 7.506c-1.61.877-4.221.879-5.836 0L2.918 36C1.307 35.124 0 32.928 0 31.1V16.366c0-1.83 1.304-4.023 2.918-4.903l13.8-7.505z"
        fillRule="evenodd"
        fill="#FFF"
      />
      <path
        fill="#2F8BE6"
        d="M38.725 21.774c5.12 0 9.27-4.202 9.27-9.387 0-5.184-4.15-9.387-9.27-9.387-5.12 0-9.27 4.203-9.27 9.387 0 5.185 4.15 9.387 9.27 9.387z"
      />
      <g fillRule="evenodd" fill="#353535">
        <path d="M25.323 28.579v-9.807c0-.888.672-1.59 1.521-1.59.849 0 1.52.702 1.52 1.59v9.808c0 .887-.671 1.59-1.52 1.59s-1.52-.703-1.52-1.591h-.001zm-2.372-4.834c0 4.38-2.35 6.528-6.06 6.528-3.713 0-5.982-2.169-5.982-6.426v-5.075c0-.888.671-1.59 1.52-1.59.848 0 1.52.702 1.52 1.59v4.993c0 2.356 1.124 3.574 2.98 3.574 1.856 0 2.981-1.178 2.981-3.47v-5.095c0-.89.671-1.592 1.52-1.592s1.52.702 1.52 1.59v4.973h.001z" />
        <path
          fill="#FFF"
          d="M38.727 16.091c-1.565 0-2.727-.849-2.727-2.143v-.021c0-.902.394-1.432 1.141-1.792-.545-.35-.899-.828-.899-1.623v-.022c0-1.133.99-2.035 2.485-2.035 1.495 0 2.485.89 2.485 2.036v.022c0 .794-.353 1.272-.899 1.622.717.393 1.142.87 1.142 1.75v.022c0 1.377-1.162 2.184-2.728 2.184zm0-4.497c.617 0 1.01-.382 1.01-.902v-.022c0-.455-.374-.868-1.01-.868s-1.01.404-1.01.858v.022c0 .52.394.912 1.01.912zm0 3.15c.768 0 1.222-.404 1.222-.923V13.8c0-.573-.515-.912-1.222-.912s-1.221.34-1.221.912v.022c0 .508.453.922 1.221.922z"
        />
      </g>
    </svg>
  )
}

export default LogoUI8
